@file:OptIn(InternalResourceApi::class)

package thedailycardioadmin.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/thedailycardioadmin.shared.generated.resources/"

internal val Res.drawable._5655678618173440: DrawableResource by lazy {
      DrawableResource("drawable:_5655678618173440", setOf(
        ResourceItem(setOf(), "${MD}drawable/5655678618173440.png", -1, -1),
      ))
    }

internal val Res.drawable._5659868492988416: DrawableResource by lazy {
      DrawableResource("drawable:_5659868492988416", setOf(
        ResourceItem(setOf(), "${MD}drawable/5659868492988416.png", -1, -1),
      ))
    }

internal val Res.drawable._5724410040287232: DrawableResource by lazy {
      DrawableResource("drawable:_5724410040287232", setOf(
        ResourceItem(setOf(), "${MD}drawable/5724410040287232.png", -1, -1),
      ))
    }

internal val Res.drawable._5759501332381696: DrawableResource by lazy {
      DrawableResource("drawable:_5759501332381696", setOf(
        ResourceItem(setOf(), "${MD}drawable/5759501332381696.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("_5655678618173440", Res.drawable._5655678618173440)
  map.put("_5659868492988416", Res.drawable._5659868492988416)
  map.put("_5724410040287232", Res.drawable._5724410040287232)
  map.put("_5759501332381696", Res.drawable._5759501332381696)
}
